/* global jQuery */

import { Module } from 'wrapper6'
import ProductService from '../services/_product-service'
import SimpleBar from 'simplebar'
import 'simplebar/dist/simplebar.css'

export default class MiniCart extends Module {
  ready () {
    MiniCart.addHoverEffect()
    MiniCart.addButtonListerners()
  }

  static addScrollBar () {
    const cartScroll = document.getElementsByClassName('cart_list')[0]
    if (cartScroll) new SimpleBar(cartScroll)
  }

  static showLoader () {
    const cart = document.getElementsByClassName('menu-mini-cart')[0]

    if (cart) {
      const loader = document.createElement('div')
      loader.classList.add('loader')

      cart.classList.add('loading')
      cart.append(loader)
    }
  }

  static removeLoader () {
    const cart = document.getElementsByClassName('menu-mini-cart')[0]

    if (cart) {
      cart.classList.remove('loading')
    }
  }

  static addHoverEffect () {
    const miniCart = jQuery('.navigation').find('.menu-mini-cart-item')

    if (miniCart.hasClass('hidden')) return

    jQuery('.navigation').on('mouseenter', '.menu-mini-cart-item', () => {
      const cart = jQuery('.navigation').find('.menu-mini-cart')
      cart.addClass('show')
    })

    jQuery('.navigation').on('mouseleave', '.menu-mini-cart-item', () => {
      const cart = jQuery('.navigation').find('.menu-mini-cart')
      cart.removeClass('show')
    })
  }

  static addButtonListerners () {
    const clearMiniCartButton = document.getElementsByClassName('empty-mini-cart-button')[0]
    const removeItemButtons = document.getElementsByClassName('remove_from_mini_cart_button')

    jQuery('.mini-cart-close').on('click', 'a.close-button', (e) => {
      e.preventDefault()

      const cart = jQuery('.menu-mini-cart')

      cart.removeClass('show')
    })

    if (clearMiniCartButton) {
      clearMiniCartButton.addEventListener('click', (e) => {
        e.preventDefault()

        MiniCart.showLoader()
        ProductService.removeAllFromMiniCart().then(data => {
          MiniCart.updateCartContents(data.data.html)
        })
        MiniCart.removeLoader()
      })
    }

    if (removeItemButtons) {
      for (let i = 0; i < removeItemButtons.length; i++) {
        const button = removeItemButtons[i]

        button.addEventListener('click', (e) => {
          e.preventDefault()
          MiniCart.showLoader()
          ProductService.removeProductFromMiniCart(button.dataset.cart_item_key).then(data => {
            MiniCart.updateCartContents(data.data.html)
          })
          MiniCart.removeLoader()
        })
      }
    }

    MiniCart.addScrollBar()
  }

  static updateCartContents (html) {
    const cart = document.getElementById('cart')
    cart.innerHTML = html

    MiniCart.addButtonListerners()
    this.addButtonListerners()

    setTimeout(() => {
      MiniCart.showCart()
    }, 250)
  }

  static showCart () {
    const miniCart = document.getElementsByClassName('menu-mini-cart-item')[0]
    const cart = miniCart.getElementsByClassName('menu-mini-cart')[0]

    cart.classList.add('show')
  }
}
